<h2 mat-dialog-title>Busqueda Persona</h2>
<mat-dialog-content class="mat-typography">
    
  
      <div class="row">
          <div class="col s12 m12 l12" style="text-align: center;">
            <p style="color: red; font-size: 16px; font-weight: bold;">Por favor seleccione la persona que desea ingresar</p>
          </div>
      </div>
  

  <mat-nav-list>
    <h3 mat-subheader>LISTADO DE PERSONAS</h3>
    <mat-list-item *ngFor="let persona of personas" (click)="personaSeleccionada(persona)">
      <mat-icon mat-list-icon>person</mat-icon>
      <h3 class="titulo-item" mat-line>
        <span style="color: grey; font-weight: bold;">Nombre:</span> {{ persona.Nombre || ''}} {{ persona.Apellido || ''}} 
        <span style="color: grey; font-weight: bold;">Tipo Documento:</span> {{ persona.DescripcionTpoIdenti || ''}} <span style="color: grey; font-weight: bold;">Numero:</span> {{ persona.NroDocId || ''}} 
      </h3> 
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-nav-list>
    
</mat-dialog-content>

<mat-dialog-actions align="end">  
  <button mat-raised-button color="primary" >Cerrar</button>  
</mat-dialog-actions>